import { render, staticRenderFns } from "./newUserResearch.vue?vue&type=template&id=627b5736&scoped=true&"
import script from "./newUserResearch.vue?vue&type=script&lang=js&"
export * from "./newUserResearch.vue?vue&type=script&lang=js&"
import style0 from "./newUserResearch.vue?vue&type=style&index=0&id=627b5736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b5736",
  null
  
)

export default component.exports